import { Footer } from "./Footer";
import Header from "./Header";

export {
    Footer,
    Header,
};